<ion-content *ngIf="didInit">
  <ion-grid *ngIf="!locationServ.distance">
    <ion-row>
      <ion-col size="12">
        <ion-icon name="location" color="primary"></ion-icon>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-text color="dark" class="ion-text-center">
          <h4><b>
              {{'Location-text' | translate}}
            </b></h4>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-button (click)="checkPerm()" expand="block" color="primary">
          {{'Allow' | translate}}
        </ion-button>
      </ion-col>

      <ion-col size="12">
        <ion-button (click)="close()" expand="block" color="primary" fill="clear">
          {{'Deny' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
  
  <ion-grid *ngIf="locationServ.distance && !locationServ.isInHotel">
    <ion-row>
      <ion-col size="12">
        <div class="distance"></div>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-text color="dark" class="ion-text-center">
          <h4><b>{{'You are so far away so we cannot receive your request.' | translate}}</b></h4>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-button (click)="getLocation()" expand="block" color="primary">
          {{'Try Again' | translate}}
        </ion-button>
      </ion-col>

      <ion-col size="12">
        <ion-button (click)="close()" expand="block" color="primary" fill="clear">
          {{'Back' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!-- Add error state handling -->
  <ion-grid *ngIf="locationError">
    <ion-row>
      <ion-col size="12">
        <ion-icon name="warning-outline" color="danger"></ion-icon>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-text color="dark" class="ion-text-center">
          <h4><b>{{'Could not determine your location. Please try again.' | translate}}</b></h4>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-button (click)="checkPerm()" expand="block" color="primary">
          {{'Try Again' | translate}}
        </ion-button>
      </ion-col>

      <ion-col size="12">
        <ion-button (click)="close()" expand="block" color="primary" fill="clear">
          {{'Back' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>